import { render, staticRenderFns } from "./ConfigDepartamentos.vue?vue&type=template&id=0bd1f560&scoped=true"
import script from "./ConfigDepartamentos.vue?vue&type=script&lang=js"
export * from "./ConfigDepartamentos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bd1f560",
  null
  
)

export default component.exports